import { gql } from "@apollo/client";

const GET_USERS = gql`
  query users(
    $params: QueryParams
    $search: String
    $type: String
    $excludeTypes: [String]
    $location: QueryOperators
  ) {
    users(
      params: $params
      search: $search
      type: $type
      excludeTypes: $excludeTypes
      location: $location
    ) {
      info {
        count
      }
      results {
        id
        firstName
        lastName
        email
        img
        type
        createdAt
        location {
          id
          name
          address {
            street
            city
            country
          }
        }
      }
    }
  }
`;

const GET_LOCATIONS = gql`
  query getLocations($params: QueryParams, $name: String) {
    locations(params: $params, name: $name) {
      results {
        id
        name
      }
    }
  }
`;

export { GET_USERS, GET_LOCATIONS };
